import { BaseController, Rx, type SubtreeModel } from "subtree.js/core";
import type { AppDeps } from "../app-deps";
import type { ActiveBroadcast } from "../core/services/broadcast-studio";

export class BroadcastStageState {
  readonly active = new Rx<ActiveBroadcast | null>(null);
  /** The camera on this device is publishing right now. */
  readonly onAir = new Rx(false);
}

export abstract class BroadcastStageActions {
  /** The `<video>` the camera renders into; null when it unmounts. */
  abstract attachVideo(element: HTMLVideoElement | null): void;
  abstract stopCamera(): void;
}

/**
 * The camera's presence, mirrored from the studio for the stage that renders
 * above the router: full frame under the cockpit, an on-air bar everywhere else.
 */
export class BroadcastStageController extends BaseController implements BroadcastStageActions {
  readonly state = new BroadcastStageState();

  constructor(
    subtree: SubtreeModel,
    readonly deps: Pick<AppDeps, "broadcastStudio">,
  ) {
    super();
    subtree.put(BroadcastStageState, this.state);
    subtree.put(BroadcastStageActions, this);
    this.sync(() => {
      this.state.active.value = deps.broadcastStudio.active;
      this.state.onAir.value = deps.broadcastStudio.onAir;
    }, [deps.broadcastStudio]);
  }

  attachVideo = (element: HTMLVideoElement | null) => {
    this.deps.broadcastStudio.attachVideo(element);
  };

  stopCamera = () => {
    this.deps.broadcastStudio.stop();
  };
}
